export default __webpack_public_path__ + "static/media/copima_logo_sm.62b4eb98.svg";